// extracted by mini-css-extract-plugin
export default {"zoomModal":"o1-z","image":"p1-z","button":"q1-z","isOverlayShown":"r1-z"};